import fileSaver from 'lib/file-saver';
import {
  DOWNLOAD_REPORT_ANALYTICS_CSV, CLIENT_ERROR_RESPONSES, ABORT_ERROR, SUCCESS_RESPONSES,
  SERVER_ERROR_RESPONSES,
} from '../constants/AppConstants';

export default async (orgId, requestParams, signal) => {
  try {
    const queryString = new URLSearchParams(requestParams).toString();

    const baseUrl = DOWNLOAD_REPORT_ANALYTICS_CSV.replace(':orgId', orgId);
    const apiUrl = `${baseUrl}?${queryString}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      signal,
    });

    if (response.status !== SUCCESS_RESPONSES.SUCCESS_OK) return { ok: false, status: response.status };

    const contentDispositionHeader = response.headers.get('Content-Disposition');
    // #genai Preserve the original null/empty-header short-circuit and default-filename fallback.
    const filename = contentDispositionHeader
      ? contentDispositionHeader.split(';')
        .find((n) => n.includes('filename='))
        .replace('filename=', '')
        .trim()
      : contentDispositionHeader;

    const blob = await response.blob();
    fileSaver.saveAs(blob, filename || 'report-analytics.csv');

    return { ok: true, status: response.status };
  } catch (error) {
    const status = error.name === ABORT_ERROR ? CLIENT_ERROR_RESPONSES.STATUS_ABORT_REQUEST : SERVER_ERROR_RESPONSES.INTERNAL_SERVER_ERROR;
    return { ok: false, status };
  }
};
